import useSWRImmutable from "swr/immutable"

import { AppError } from "../../../../../errors/errorProcessors"
import { invalidApiDataError } from "../../../../../errors/recognisedErrors"
import { getClientProtected } from "../../../clients/clients"
import { startNewAmendmentMapper } from "../../../mappers/registerDevice/startNewAmendmentMapper"
import { NEW_AMENDMENT_CONFIG } from "../../../swrConfig"
import { TNewAmendmentResponse } from "../../../types/devices/ttr/publishDeviceTypes"
import { START_NEW_AMENDMENT } from "../../../urls/private"

interface IUseStartNewAmendmentOutput {
    data?: TNewAmendmentResponse
    isLoading: boolean
    isValidating: boolean
    error?: AppError
}

/**
 * Hook for starting a new device amendment.
 * Returns data for the device to amend, which is then used to populate the device context
 */
const useStartNewAmendment = (
    deviceRef: string
): IUseStartNewAmendmentOutput => {
    const { data, error, isLoading, isValidating } = useSWRImmutable(
        START_NEW_AMENDMENT(deviceRef),
        async (url: string): Promise<TNewAmendmentResponse> => {
            try {
                const response = await getClientProtected(url)
                return startNewAmendmentMapper.map(response)
            } catch {
                throw invalidApiDataError("Failed to start new amendment")
            }
        },
        NEW_AMENDMENT_CONFIG
    )

    return {
        data,
        isLoading,
        isValidating,
        error,
    }
}

export default useStartNewAmendment
